import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiVisa, PagingResponseModel } from '../../shared';
import {
  CfpEngagementHdrQueryCriteriaClass,
  CfpEngagementHdrCriteriaModelQuery
} from '../../../criteria/cfp-engagement-hdr-query-criteria.model';

@Injectable({
  providedIn: 'root'
})
export class CfpEngagementHdrService extends BaseApiTemplateService<any> {

  static readonly CFP_ENGAGEMENT_HDR_SUBPATH = Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'cfp/engagement-hdrs/';

  constructor(http: HttpClient) {
    super();
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      CfpEngagementHdrService.CFP_ENGAGEMENT_HDR_SUBPATH +
      BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_login_url =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      CfpEngagementHdrService.CFP_ENGAGEMENT_HDR_SUBPATH +
      BaseApiTemplateService.LOGIN_EP;
    this.httpClient = http;
  }

  public getByCriteriaBackofficeEp(
    visa: ApiVisa,
    criteria?: CfpEngagementHdrQueryCriteriaClass
  ): Observable<PagingResponseModel<any>> {
    const criteriaQuery = new CfpEngagementHdrCriteriaModelQuery(criteria);
    const url = (visa.api_domain_url ? visa.api_domain_url + this.endpoint_path : this.apiUrl)
      + '/query?' + criteriaQuery.query;
    return this.httpClient.get<PagingResponseModel<any>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  public getByCriteriaLoginEp(
    visa: ApiVisa,
    criteria?: CfpEngagementHdrQueryCriteriaClass
  ): Observable<PagingResponseModel<any>> {
    const criteriaQuery = new CfpEngagementHdrCriteriaModelQuery(criteria);
    const loginApiUrl = this.endpoint_path_login_url && visa.api_domain_url
      ? visa.api_domain_url + this.endpoint_path_login_url
      : this.apiUrl;
    const url = loginApiUrl + '/query?' + criteriaQuery.query;
    return this.httpClient.get<PagingResponseModel<any>>(
      url,
      this.getHttpHeader(visa)
    );
  }
}
